export const isNewDiffCheckerFeatureEnabled = () => {
    const isEnabled = process.env.REACT_APP_DIFF_CHECKER_FEATURE_ENABLED?.toString() === "true" || false;
  return isEnabled;
}

// FIXME: remove after — temporary gate so Legal consent shows only in dev/qa
// while the feature is validated (hidden in uat/prod). Detected from the host,
// so no env wiring is needed. To enable everywhere later, make this
// `return true;`, then delete this flag and its call sites.
export const isLegalConsentEnabled = () => {
  const host = (typeof window !== "undefined" ? window.location.hostname : "").toLowerCase();
  return ["localhost", "127.0.0.1", "dev", "qa"].some((k) => host.includes(k));
};

// Ask Allie is off unless REACT_APP_ASK_ALLIE_ENABLED is explicitly "true".
// Missing/unset env var (e.g. no CI wiring yet) safely defaults to disabled.
export const isAskAllieEnabled = () => {
  const isEnabled = process.env.REACT_APP_ASK_ALLIE_ENABLED?.toString() === "true" || false;
  return isEnabled;
}